var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal", attrs: { "select-cy": "confirm" } },
    [
      _c("div", { class: "card confirm " + _vm.color }, [
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "icon" }, [_vm._v("!")]),
          _c("div", { staticClass: "headline" }, [
            _vm._v(_vm._s(_vm.headline))
          ]),
          _c("div", { staticClass: "details" }, [_vm._v(_vm._s(_vm.details))])
        ]),
        _c("div", { staticClass: "commands" }, [
          _c(
            "button",
            {
              staticClass: "secondary",
              attrs: { type: "button", "select-cy": "confirm-cancel" },
              on: {
                click: function($event) {
                  return _vm.confirm(false)
                }
              }
            },
            [_vm._v("Cancel")]
          ),
          _c(
            "button",
            {
              staticClass: "primary",
              attrs: { type: "button", "select-cy": "confirm-accept" },
              on: {
                click: function($event) {
                  return _vm.confirm(true)
                }
              }
            },
            [_vm._v(_vm._s(_vm.action))]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }